export default __webpack_public_path__ + "static/media/FAC1.afd2e6fe.jpg";